import apiBase from './apiBase';

export default class Api {
  static async getStayPlans(planId) {
    return await apiBase.get('/api/camp_entry/stayplans', {
      plan_id: planId,
    });
  }

  static async getCourses(planId, includeCourseId = null) {
    const params = { plan_id: planId };
    if (includeCourseId) {
      params.include_course_id = includeCourseId;
    }
    return await apiBase.get('/api/camp_entry/plan_courses', params);
  }

  static async getPlanStayplanMeetingTimes(planId, stayplanId) {
    return await apiBase.get('/api/camp_entry/plan_stayplan_meeting_times', {
      plan_id: planId,
      stayplan_id: stayplanId,
    });
  }

  static async getRentals(campId, planId, courseId) {
    return await apiBase.get('/api/camp_entry/rentals', {
      camp_id: campId,
      plan_id: planId,
      course_id: courseId,
    });
  }

  static async getPcTypes(courseId) {
    return await apiBase.get('/api/camp_entry/pc_types', {
      course_id: courseId,
    });
  }

  static async getPayments(campId) {
    return await apiBase.get('/api/camp_entry/payments', {
      camp_id: campId,
    });
  }

  // 年齢判定に使う生年月日。確認画面・申込変更画面はサーバーが確定値(student_birthday)を渡す。
  // 参加者情報の入力中は birthday_year/month/day、既存参加者を選び直した場合は
  // 古い birthday_year/month/day が残るため student_attributes.birthday を優先する
  static birthdayFor(values) {
    const isIsoDate = (value) => /^\d{4}-\d{2}-\d{2}/.test(value);
    if (isIsoDate(values.student_birthday)) {
      return values.student_birthday;
    }

    const studentStatus = values.parent_status?.student_statuses_attributes?.[0] || {};
    const studentAttributes = studentStatus.student_attributes || {};
    if ((studentAttributes.id || studentStatus.student_id) && isIsoDate(studentAttributes.birthday)) {
      return studentAttributes.birthday;
    }

    const { birthday_year, birthday_month, birthday_day } = values;
    if (birthday_year && birthday_month && birthday_day) {
      return `${birthday_year}-${String(birthday_month).padStart(2, '0')}-${String(birthday_day).padStart(2, '0')}`;
    }
    return isIsoDate(studentAttributes.birthday) ? studentAttributes.birthday : null;
  }

  static async getPrices(values) {
    let camp_rentals = values.parent_status.student_statuses_attributes[0].student_status_camp_rentals_attributes;
    // camp_rentalsはarrayと{0: {}}というパターンを揃えるので、一度arrayに変換する
    camp_rentals = camp_rentals === undefined ? [] : Object.keys(camp_rentals).map((key) => camp_rentals[key])
      .filter((x) => x != null && x.use_rental === 'true' && x.camp_rental_id !== '-1')
      .map((x) => x.camp_rental_id);
    const params = {
      plan_id: values.parent_status.student_statuses_attributes[0].plan_id,
      stayplan_id: values.parent_status.student_statuses_attributes[0].stayplan_id,
      rental_ids: camp_rentals,
    };
    if (values.parent_status.payment_id) {
      params.payment_id = values.parent_status.payment_id;
    }
    if (values.parent_status.student_statuses_attributes[0].payment_id) {
      params.payment_id = values.parent_status.student_statuses_attributes[0].payment_id;
    }
    if (values.any_code) {
      params.coupon_code = values.any_code;
    }
    // 13歳未満はAIレンタルを利用できないため、サーバ側で料金から除外する判定に使う
    const birthday = Api.birthdayFor(values);
    if (birthday) {
      params.birthday = birthday;
    }
    if (values.parent_status.student_statuses_attributes[0].created_at) {
      params.apply_date = values.parent_status.student_statuses_attributes[0].created_at;
    }
    return await apiBase.post('/api/camp_entry/prices', params);
  }
}
